// @flow
import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import actionKeys from './agreementAddOnActionKeys';
import type {
  CreateAndActivateBusinessManagementToolsSubscriptionRequest,
  CreateAndActivateBusinessManagementToolsSubscriptionResponse,
  GetBusinessManagementToolsAgreementAddOnEligibilityRequest,
  GetBusinessManagementToolsAgreementAddOnEligibilityResponse,
  CancelBusinessManagementToolsSubscriptionRequest,
  CancelBusinessManagementToolsSubscriptionResponse,
} from './agreementAddOnService';
import type { AsyncState } from '../../../app/types';

export type CreateAndActivateBusinessManagementToolsSubscriptionState =
  AsyncState<
    CreateAndActivateBusinessManagementToolsSubscriptionRequest,
    CreateAndActivateBusinessManagementToolsSubscriptionResponse
  >;

const businessManagementToolsActivation =
  AsyncRequest.createReducer(actionKeys.CREATE_AND_ACTIVATE_BUSINESS_MANAGEMENT_TOOLS_SUBSCRIPTION);

export type BusinessManagementToolsActivationState = {
  businessManagementToolsActivation: CreateAndActivateBusinessManagementToolsSubscriptionState
}


export type GetBusinessManagementToolsAgreementAddOnEligibilityState =
  AsyncState<
    GetBusinessManagementToolsAgreementAddOnEligibilityRequest,
    GetBusinessManagementToolsAgreementAddOnEligibilityResponse
  >;

const businessManagementToolsEligibility =
  AsyncRequest.createReducer(actionKeys.GET_BUSINESS_MANAGEMENT_TOOLS_AGREEMENT_ADD_ON_ELIGIBILITY);

export type BusinessManagementToolsEligibilityState = {
  businessManagementToolsEligibility: GetBusinessManagementToolsAgreementAddOnEligibilityState
}

export type CancelBusinessManagementToolsSubscriptionState =
  AsyncState<
    CancelBusinessManagementToolsSubscriptionRequest,
    CancelBusinessManagementToolsSubscriptionResponse
  >;

const businessManagementToolsCancellation =
  AsyncRequest.createReducer(actionKeys.CANCEL_BUSINESS_MANAGEMENT_TOOLS_SUBSCRIPTION);

export type BusinessManagementToolsCancellationState = {
  businessManagementToolsCancellation: CancelBusinessManagementToolsSubscriptionState
}


export default (combineReducers({
  businessManagementToolsActivation,
  businessManagementToolsEligibility,
  businessManagementToolsCancellation,
}): any);



// WEBPACK FOOTER //
// ./src/app/common/agreementAddOn/agreementAddOnReducer.js